import React, { useState } from 'react';
import { withStyles, MenuItem, Select, Typography, Paper, Button, StepContent, InputLabel, StepLabel, Step, Stepper } from "@material-ui/core";
import History from "../../../History";

const styles = theme => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
        borderRadius: '1px' 
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
});

const MoveColliDelete = (props) => {
    const { deleteColli, onBulkDeleteCollis, activeCustomerID, colliList, classes, translations } = props
    const [value, setValue] = useState({});

    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());
    const steps = colliList.filter(val => deleteColli.includes(val.value));

    const isStepOptional = (step) => {
        return step === 1;
    };

    const isStepFailed = (step) => {
        return step;
    };

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    const handleNext = async (index, colliID) => {
        let result = await onBulkDeleteCollis({ Relocate: value[colliID.value], ColliIDs: [colliID.value], ActiveCustomerID: activeCustomerID, Name: colliID.displayValue });
        if (result) {
            let newSkipped = skipped;

            if (isStepSkipped(activeStep)) {
                newSkipped = new Set(skipped.values());
                newSkipped.delete(activeStep);
            }
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
            return
        }
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(index);
            return newSkipped;
        });
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleSkip = (index) => {
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(index);
            return newSkipped;
        });
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleChange = (event, from) => {
        let array = []
        array.push({ [`ColliFrom`]: from, [`ColliTo`]: event.target.value })
        setValue({ ...value, [from]: array });
    };

    const handleClose = (event, from) => {
        History.goBack();
    };

    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    const values = value[label.value] && value[label.value][0] && value[label.value][0].ColliTo ? value[label.value][0].ColliTo : ''
                    if (isStepOptional(index)) {
                        labelProps.optional = (
                            <Typography variant="caption" color="error">
                                ERROR
                            </Typography>
                        );
                    }
                    if (isStepFailed(index)) {
                        labelProps.error = true;
                    }
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={label.displayValue} {...stepProps}>
                            <StepLabel>{label.displayValue}</StepLabel>
                            <StepContent>
                                <div>
                                    <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                                        {translations['colli_to'] || 'Colli to'}
                                    </InputLabel>
                                    {<Select
                                        name={`ColliTo`}
                                        label={translations['go_to'] || 'Go to'}
                                        margin={"dense"}
                                        fullWidth={true}
                                        onChange={event => handleChange(event, label.value)}
                                        value={values}
                                    >
                                        {(colliList.filter(val => !deleteColli.includes(val.value))).map(option => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.displayValue}
                                            </MenuItem>
                                        ))}
                                    </Select>}

                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => handleSkip(index)}
                                        className={classes.button}
                                    >
                                        {translations['skip'] || 'Skip'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={!values}
                                        onClick={() => handleNext(index, label)}
                                        className={classes.button}
                                    >
                                        {translations['move_delete'] || 'Move delete'}
                                    </Button>
                                </div>
                            </StepContent>

                        </Step>
                    );
                })}
            </Stepper>
            <div>
                {activeStep === steps.length && (
                    <Paper square elevation={0} className={classes.resetContainer}>
                        <Button onClick={handleClose} variant="contained"
                            color={'primary'} style={{ width: '100%' }} className={classes.submit}>
                            {translations['finish'] || 'Finish'}
                        </Button>
                    </Paper>
                )}
            </div>
        </div >
    );
}
export default withStyles(styles, { withTheme: true })(MoveColliDelete)
